export const profileImageLink = 'http://localhost:3333/users/profileImage/';
